"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_query_1 = require("react-query");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var crumb_nav_1 = __importDefault(require("../../../components/crumb_nav"));
var error_message_1 = __importDefault(require("../../../components/error_message"));
var save_button_1 = require("../../../components/save_button");
var update_customer_1 = require("../../../mutations/update-customer");
var formatPhoneNumber = function (phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match)
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    return '';
};
exports.default = (function (props) {
    if (!props.customer)
        return null;
    var customer = props.customer;
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var _a = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            first_name: customer.first_name,
            last_name: customer.last_name,
            email: customer.email,
            billing_phone: customer.billing_phone,
        },
    }), register = _a.register, handleSubmit = _a.handleSubmit, watch = _a.watch, setValue = _a.setValue, errors = _a.errors;
    var formValues = watch();
    var fieldContainerClassName = function (fieldName) {
        return (0, classnames_1.default)({ 'form-input': true, 'with-error': errors && errors[fieldName], 'is-filled': formValues && !!formValues[fieldName] });
    };
    var _b = (0, react_query_1.useMutation)('updateCustomer', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_customer_1.UPDATE_CUSTOMER, variables); }, {
        onSuccess: function (data) {
            callout.success('Successfully Updated Profile!');
            queryClient.invalidateQueries('getCustomerSubscriptions');
        },
        onError: function (updateCustomerError) {
            callout.alert('Unable to update profile');
        },
        // Look into updating cache directly
    }), mutateCustomer = _b.mutateAsync, isLoading = _b.isLoading, error = _b.error, isError = _b.isError;
    var onSubmitCustomer = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var newCustomerData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutateCustomer({ updates: data })];
                case 1:
                    newCustomerData = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    callout.alert('Unable to update profile');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
    return (React.createElement(React.Fragment, null,
        React.createElement(crumb_nav_1.default, { current: 'Editing Profile' }),
        React.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' },
            React.createElement("img", { className: 'padding-right-3', src: window.accountApp.iconUrls.profile }),
            "Your Account Details"),
        React.createElement("div", { className: 'margin-bottom-8 account-container' },
            React.createElement("div", { className: 'panel' },
                React.createElement("div", { className: 'account-subheader' }, "Profile"),
                React.createElement("div", null,
                    React.createElement("p", null,
                        customer.first_name,
                        " ",
                        customer.last_name),
                    React.createElement("p", null, customer.email),
                    React.createElement("p", null, formatPhoneNumber(customer.billing_phone))),
                React.createElement("div", null,
                    React.createElement("div", { className: fieldContainerClassName('first_name') },
                        React.createElement("label", null,
                            React.createElement("input", { type: 'text', name: 'first_name', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', placeholder: 'First Name', ref: register({
                                    required: {
                                        value: true,
                                        message: 'First name is required',
                                    },
                                }) }),
                            React.createElement("span", { className: 'placeholder' }, "First Name")),
                        React.createElement(error_message_1.default, { error: errors.first_name })),
                    React.createElement("div", { className: fieldContainerClassName('last_name') },
                        React.createElement("label", null,
                            React.createElement("input", { name: 'last_name', autoComplete: 'family-name', type: 'text', placeholder: 'Last Name', ref: register({
                                    required: {
                                        value: true,
                                        message: 'First name is required',
                                    },
                                }) }),
                            React.createElement("span", { className: 'placeholder' }, "Last Name")),
                        React.createElement(error_message_1.default, { error: errors.last_name })),
                    React.createElement("div", { className: fieldContainerClassName('email') },
                        React.createElement("label", null,
                            React.createElement("input", { name: 'email', autoComplete: 'email', type: 'text', placeholder: 'Email', ref: register({
                                    required: {
                                        value: true,
                                        message: 'Email is required',
                                    },
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Invalid email format',
                                    },
                                }) }),
                            React.createElement("span", { className: 'placeholder' }, "Email")),
                        React.createElement(error_message_1.default, { error: errors.email })),
                    React.createElement("div", { className: fieldContainerClassName('billing_phone') },
                        React.createElement("label", null,
                            React.createElement("input", { name: 'billing_phone', autoComplete: 'phone', type: 'text', placeholder: 'Phone', ref: register({
                                    required: {
                                        value: true,
                                        message: 'Phone is required',
                                    },
                                    minLength: {
                                        value: 6,
                                        message: 'Phone is too short',
                                    },
                                    maxLength: {
                                        value: 12,
                                        message: 'Phone is too long',
                                    },
                                }) }),
                            React.createElement("span", { className: 'placeholder' }, "Phone")),
                        React.createElement(error_message_1.default, { error: errors.billing_phone })),
                    React.createElement(save_button_1.SaveButton, { onClick: onSubmitCustomer, isLoading: isLoading }))))));
});
